import axios from "axios";

import {
  forbiddenEmptyCustomFields,
  forbiddenInvalidUserRole,
  forbiddenPausePortal,
  forbiddenUserIsSanctioned,
  forbiddenWelcomeQuestionsNotAnswered,
  logOutInterceptor,
  requestConfigInterceptor,
  setupRequestInterceptors,
  setupResponseInterceptors,
  tokenExpiration,
} from "@api/interceptors";

const axiosApiInstance = axios.create();

setupRequestInterceptors(axiosApiInstance, [requestConfigInterceptor]);

setupResponseInterceptors(axiosApiInstance, [
  logOutInterceptor,
  forbiddenEmptyCustomFields,
  forbiddenWelcomeQuestionsNotAnswered,
  forbiddenUserIsSanctioned,
  forbiddenInvalidUserRole,
  forbiddenPausePortal,
  tokenExpiration,
]);

export default axiosApiInstance;
